var _defs, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgMegaphone(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 58.238,
    height: 66.217,
    viewBox: "0 0 58.238 66.217",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".a{fill:#00aba6;}"))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(-30.849)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(30.849 2.47)"
  }, /*#__PURE__*/React.createElement("path", {
    className: "a",
    d: "M84.667,42.741,62.725,20.8a5.819,5.819,0,0,0-8.937,7.37l-.031.153A40.6,40.6,0,0,1,42.619,49.133L32.555,59.2a5.815,5.815,0,0,0,0,8.228l5.485,5.485a5.815,5.815,0,0,0,8.228,0L47.64,71.54l9.6,9.6a5.818,5.818,0,1,0,8.228-8.228L61.354,68.8l1.371-1.371a5.815,5.815,0,0,0,0-8.228l-.932-.932a40.6,40.6,0,0,1,15.352-6.557l.155-.031a5.825,5.825,0,0,0,7.368-.709h0A5.825,5.825,0,0,0,84.667,42.741ZM43.526,70.168a1.939,1.939,0,0,1-2.743,0L35.3,64.683a1.938,1.938,0,0,1,0-2.743l9.6-9.6,8.228,8.228Zm19.2,5.485A1.939,1.939,0,0,1,59.982,78.4l-9.6-9.6,2.743-2.743ZM55.868,63.311c.583-.583,1.456-1.476,2.833-2.652l1.281,1.281a1.938,1.938,0,0,1,0,2.743l-1.371,1.371Zm.082-5.4-8.393-8.393A44.413,44.413,0,0,0,57,31.53L73.936,48.466A44.411,44.411,0,0,0,55.95,57.908Zm25.974-9.682a1.938,1.938,0,0,1-2.743,0L57.239,26.284a1.939,1.939,0,1,1,2.743-2.743L81.924,45.484A1.942,1.942,0,0,1,81.924,48.226Z",
    transform: "translate(-30.849 -19.098)"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(40.215 42.001)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(0)"
  }, /*#__PURE__*/React.createElement("path", {
    className: "a",
    d: "M109.319,325.33a1.939,1.939,0,0,0-2.743,0l-2.743,2.743a1.939,1.939,0,0,0,2.743,2.743l2.743-2.743A1.939,1.939,0,0,0,109.319,325.33Z",
    transform: "translate(-103.266 -324.762)"
  }))), /*#__PURE__*/React.createElement("g", {
    transform: "translate(69.693)"
  }, /*#__PURE__*/React.createElement("path", {
    className: "a",
    d: "M333.133,0a1.939,1.939,0,0,0-1.94,1.939V5.818a1.939,1.939,0,0,0,3.879,0V1.939A1.939,1.939,0,0,0,333.133,0Z",
    transform: "translate(-331.194)"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(81.329 15.515)"
  }, /*#__PURE__*/React.createElement("path", {
    className: "a",
    d: "M426.987,119.966h-3.879a1.939,1.939,0,1,0,0,3.879h3.879a1.939,1.939,0,1,0,0-3.879Z",
    transform: "translate(-421.169 -119.966)"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(77.451 3.879)"
  }, /*#__PURE__*/React.createElement("path", {
    className: "a",
    d: "M398.368,30.559a1.939,1.939,0,0,0-2.743,0l-3.879,3.879a1.939,1.939,0,1,0,2.743,2.743l3.879-3.879A1.939,1.939,0,0,0,398.368,30.559Z",
    transform: "translate(-391.178 -29.991)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMegaphone);
export default __webpack_public_path__ + "static/media/megaphone.f66690045b34cb63aaab61ae982c5583.svg";
export { ForwardRef as ReactComponent };